// extracted by mini-css-extract-plugin
export var closeSection = "CloseSection-module--closeSection--JrIhm";
export var closeSectionContainer = "CloseSection-module--closeSectionContainer--Ijux4";
export var image = "CloseSection-module--image--dW09E";
export var text = "CloseSection-module--text--mRKnW";
export var textContainer = "CloseSection-module--textContainer--qKoua";
export var title = "CloseSection-module--title--XFsrx";